
export const formFields = {
    addTypeFacebook: {
        key: 'addTypeFacebook',
        label: '',
        placeholder: '',
        required: true,
        displayLayout: 'col-sm-12',
        requiredMessage: 'This field is required.',
        options: [{ id: 1, value: 'Use Infomo', checked: false },
        { id: 0, value: 'Link Facebook Account', checked: false }],
      }
}

export const radioBtn = [
    { key: "1", value: "Manually Enter Account Details", checked: false },
    { key: "2", value: "Link Facebook Account", checked: false },
]